import './index.css'

import { datadogRum } from '@datadog/browser-rum'
import * as React from 'react'
import { useLocation } from 'react-router-dom'

import Button from 'components/ui/button'
import { useTranslation } from '@disco/i18n/use-translation'

const DiscoPlaylistList = ({
  searchParams,
  disabled,
}: {
  searchParams: string
  disabled?: boolean
}): React.ReactElement<'div'> => {
  const { t } = useTranslation('inboxes')
  const location = useLocation()

  return (
    <div className="disco-playlist-link">
      <span className="disco-playlist-link__question">
        {t('inboxes:areYouOnDiscoAlready', 'Are you on DISCO already?')}
      </span>
      <Button
        appearance="primary"
        caption={t('inboxes:sendYourOwnPlaylist', 'Send your own Playlist')}
        link={`${location.pathname}select-playlist/?${new URLSearchParams(
          searchParams,
        ).toString()}`}
        disabled={disabled}
        onClick={() =>
          datadogRum.addAction('Public inbox upload send own playlist clicked')
        }
      />
    </div>
  )
}

export default DiscoPlaylistList
